import { render, staticRenderFns } from "./QuestionsInquiryInfo.vue?vue&type=template&id=6758408a&scoped=true&"
import script from "./QuestionsInquiryInfo.vue?vue&type=script&lang=ts&"
export * from "./QuestionsInquiryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsInquiryInfo.vue?vue&type=style&index=0&id=6758408a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6758408a",
  null
  
)

export default component.exports